module.exports = __webpack_public_path__ + "quicksilver/static/media/meals.8feec35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Meals/img/meals.png
// module id = 581
// module chunks = 0